import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/stores/useAuthStore';

const navItems = [
  { path: '/', label: 'Dashboard' },
  { path: '/boundaries', label: 'Boundaries' },
];

export function NavLinks() {
  const isSuperAdmin = useAuthStore((s) => s.manager?.is_super_admin ?? false);

  const items = isSuperAdmin
    ? [...navItems, { path: '/organizations', label: 'Organizations' }]
    : navItems;

  return (
    <nav className="flex items-center gap-1">
      {items.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/'}
          className={({ isActive }) =>
            cn(
              'px-3 py-2 text-sm font-medium text-white/80 transition-colors hover:text-white',
              isActive && 'border-b-2 border-brand-gold text-white'
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
